import jaLocale from 'element-ui/lib/locale/lang/ja' //引入element日文语言包

const jp = {
  header: {
    home: 'ホーム',
    yewu: '業務',
    xiangmu: 'プロジェクト',
    zhuanjia: 'スペシャリスト',
    xueyuan: 'アカデミー',
    zhaopin: '採用情報',
    xinwen: 'ニュース',
    guanyu: '私たちについて',
    lianxi: 'お問い合わせ',
    yxt: "ゲームエフェクト",
    yxd: "ゲームアニメーション",
    djm: "3Dゲームモデリング",
    yx: "ゲームイラスト"
  },
  home: {
    mjnet: '名匠ネットワーク',
    art: 'クリエイター',
    guoneiwai: '',
    kehu: 'グローバルのクライアント',
    cpxm: 'プロジェクト',
    ywhp: '顧客満足度',
    jpgzs: '優良スタジオ',
    mjxy: '名匠アカデミー',
    hyzj: '業界エキスパート',
    ywfb: '事業展開',
    yxkflc: 'ゲーム開発フロー',
    jxxm: '選りすぐりのプロジェクト',
    khpj: 'お客様の声',
    xw: 'ニュース',
    more: '詳しく見る',
    lookM: '詳しく見る',
    syg: '前へ',
    xyg: '次へ'
  },
  vovation: {
    ywfl: '事業カテゴリー',
    yzxm: '高品質の作品'
  },
  project: {
    yzxm: '優秀プロジェクト',
    zwgd: 'これ以上の表示項目はありません',
    xmbj: 'プロジェクト概要',
    xmcg: 'プロジェクト成果'
  },
  special: {
    jpgzs: '優良スタジオ',
    hyzj: '業界エキスパート',
    cyal: '実績例'
  },
  college: {
    hyxz: '業界選択',
    zyjs: 'コース紹介',
    wlfz: '将来のキャリアパス',
    kcap: 'カリキュラム',
    sjap: '（4-5ヶ月）※実際の日程により異なる',
    wmys: '当アカデミーの特徴',
    szjs: '講師陣紹介',
    xyjs: 'アカデミー概要',
    gszp: '会社の作品',
    xyzp: '受講生作品集',
    xydt: 'アカデミーニュース',
    xxwc: '詳細はWeChatの公式アカウントにご覧ください',
    xxew: '左のQRコードから詳細をご確認いただけます',
    glx: 'マネジメントライン',
    jsx: 'テクニカルライン',
    dxzz: 'エフェクト主任',
    dxzz_desc: 'チームのエフェクト作成とプロセス管理',
    zg: '課長',
    zg_desc: '人材選抜、プロジェクトの品質管理',
    zm: 'アートディレクター',
    zm_desc: 'スタイルのコントロール、キーエフェクトのクリエイティブデザイン',
  },
  recruit: {
    zxns: '採用情報',
    zpzw: '募集職種',
    search: '職種を検索（Enterキーで検索）',
    ly: '分野を選択',
    lyl: '分野',
    td: 'チームを選択',
    tdt: 'チーム',
    dd: '勤務地を選択',
    dzd: '勤務地',
    cz: '操作',
    ckgd: '詳しく見る',

    zwxx: '職務内容',
    zz: '職務内容',
    yq: '応募要件',
    sqgw: 'この職種に応募',
    jlsc: '履歴書アップロード',
    xzwj: 'ファイルを選択',
    zcgs: '対応ファイル形式',
    xm: 'お名前',
    nl: '年齢',
    yx: 'メールアドレス',
    sjhm: '電話番号',
    tj: 'ていしゅつ',

    qname: 'お名前を入力してください',
    qphone: '電話番号を入力してください',
    qtruephone: '正しい電話番号を入力してください',
    qemail: 'メールアドレスを入力してください',
    qtruemail: '正しいメールアドレスを入力してください',
    qage: '年齢を入力してください'
  },
  new: {
    gsxw: '企業ニュース',
    syp: '前の記事',
    xyp: '次の記事'
  },
  about: {
    qyjzg: '企業理念',
    fzlc: '沿革',
    mjtd: '名匠チーム',
    gsfw: '社風'
  },
  contact: {
    hello: 'こんにちは',
    lt: 'お客様のニーズに',
    gz: 'お客様のご要望をお聴かせいただけます。',
    name: 'お名前',
    gsmc: '貴社名',
    lxfs: 'ご連絡先',
    xq: 'ご要望',
    qsr: 'ご記入ください',
    tj: '送信',
    qxfgs: '支社一覧',
    qtruemobile: '正しい形式で入力してください',
    qgs: '正しい電話番号を入力してください',
    neirong: '全ての項目をご入力ください',

    qsrxm: 'お名前をご入力ください',
    qsrgsmc: '会社名をご入力ください',
    qsrlxfs: 'ご連絡先をご入力ください',
    qsrxq: 'ご要望をご入力ください'
  },
  ...jaLocale
}

export default jp;